var map = {
	"./cart-icon-audio.svg": "1571",
	"./collect-icon-audio.svg": "d5b3",
	"./download-icon-audio.svg": "56cd",
	"./pause-icon-audio.svg": "d48e",
	"./play-icon-audio.svg": "3f44",
	"./share-icon-audio.svg": "a28c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "543e";